import React = require('react');
import { AuthenticationType } from '~src/settings/types/IServerSettingsUnauthenticated';
import { IGetSiteSamlLoginInfoResult } from '~src/ts/ServerApi/types/IGetSiteSamlLoginInfoResult';
import { ExternalIdPLogin } from './ExternalIdPLogin';
import { LoginPage } from './LoginPage';
import { RootLoginUiProps } from './RootLoginUi';
import { SamlLogin } from './SamlLogin';
import { SiteSpecificSamlLoginForm } from './SiteSpecificSamlForm';
import { UsernameAndPasswordLogin } from './UsernameAndPasswordLogin';

export interface SiteSpecificSamlLoginProps extends RootLoginUiProps {
  serverAuthType: AuthenticationType;
}

export function SiteSpecificSamlLogin(props: SiteSpecificSamlLoginProps) {

  const [waitingForUsername, setWaitingForUsername] = React.useState(true);
  const [currentUsername, setCurrentUsername] = React.useState('');
  const [siteSamlInfo, setSiteSamlInfo] = React.useState(null);

  function onUsernameChange(newUsername: string) {
    // If the user changes the username after we calculate their auth type,
    // we go back to the state where we are waiting for the username.
    setCurrentUsername(newUsername);
    setWaitingForUsername(true);
    setSiteSamlInfo(null);
  }

  if (waitingForUsername) {
    // Render the form that waits for the username and triggers the auth type based on it.
    return <LoginPage>
      <SiteSpecificSamlLoginForm {...props}
        initialUsername={currentUsername}
        kickOffLoginForUser={(username: string, siteSamlInfo: IGetSiteSamlLoginInfoResult) => {
          setCurrentUsername(username);
          setSiteSamlInfo(siteSamlInfo);
          setWaitingForUsername(false);
        }} />
    </LoginPage>;
  } else {
    if (siteSamlInfo) {
      // It is a site-saml user, kick off the site-saml flow.
      return <ExternalIdPLogin {...props} siteSamlInfo={siteSamlInfo} />;
    } else {
      // User is configured for server-default authentication.
      switch (props.serverAuthType) {
        case AuthenticationType.Saml:
          return <SamlLogin {...props}
            initialUsername={currentUsername}
            onUsernameChange={onUsernameChange} />;

        case AuthenticationType.AD:
        case AuthenticationType.Local:
          return <UsernameAndPasswordLogin {...props}
            initialUsername={currentUsername}
            onUsernameChange={onUsernameChange} />;

        default:
          throw new Error('Invalid auth type');
      }
    }
  }
}
